import IncomeSpendChartWidget from "./IncomeSpendChartWidget";

export default IncomeSpendChartWidget;
